import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda } from 'src/app/shared/utils';
import { basicAlert, setConfigTableModalBusqueda3, timerOut } from 'src/app/shared/utils';
import { TableService } from 'src/app/services/ngtable.service';

@Component({
  selector: 'app-modal-busqueda-interlocutor',
  templateUrl: './modal-busqueda-interlocutor.component.html',
  styleUrls: ['./modal-busqueda-interlocutor.component.css']
})
export class ModalBusquedaInterlocutorComponent implements OnInit {

  @Input() interlocutores: [];
  @Input() cabeceraTexto = '';
  @Input() razonsocialBusqueda = '';
  @Input() nombresBusqueda = '';
  dtTrigger: Subject<null> = new Subject();
  @Input() cabeceraTipo = '';
  tipotitulobusqueda: any
  position: number = 1;
  index: number = 0;
  //dtTrigger: Subject<null> = new Subject();
  //dtOptions: any = {};
  lsttemp
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(
    private modalService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private TableService: TableService,

  ) { }
  @ViewChild('codArticuloI') codArticuloInput: ElementRef;
  interlocutores_temp
  ngOnInit(): void {
    console.log('Modal cabececra tipo')
    console.log(this.cabeceraTipo)

    this.interlocutores_temp = this.interlocutores;
    this.position = 0;
    this.index = this.interlocutores.length - 1;
    this.lsttemp = this.interlocutores[this.position]
    //this.cabeceraTipo ='pruebaa'
    if (this.cabeceraTipo == '0') {
      this.tipotitulobusqueda = ':'
    } else if (this.cabeceraTipo == '1') {
      this.tipotitulobusqueda = ' :'
    } else {
      this.tipotitulobusqueda = ''
    }
    //this.dtOptions = setConfigTableModalBusqueda(false);
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });

    setTimeout(() => {
      //this.dtTrigger.next();  

      this.spinnerService.activarLoading(false);
    }, 500);
    this.TableService.tableList = this.interlocutores_temp;

    /*if(this.nombresBusqueda[0]=='%'){
      this.csearchTerm = this.nombresBusqueda.substring(1,this.nombresBusqueda.length)
    }else{
      this.csearchTerm = this.nombresBusqueda
    }*/

    //this.interlocutores = this.cfilter(this.csearchTerm);
  }

  onClick(data: any): void {
    this.spinnerService.activarLoading(true);
    this.modalService.close(data);
    //this.dtTrigger.unsubscribe();
  }

  cancelar(): void {
    this.modalService.dismiss('canceling');
    //this.dtTrigger.unsubscribe();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let x = event.keyCode;

    if (this.interlocutores.length > 0) {
      if (x === 13) {//enter 13
        this.onClick(this.interlocutores[this.position])
        this.lsttemp = this.interlocutores[this.position]

      }

      if (x === 38) {//38 arriba
        if (this.position > 0) {
          this.position--;
          this.lsttemp = this.interlocutores[this.position]

          // console.log(this.position)
          // console.log(this.articulos[this.position])
        }
      }

      if (x === 40) {//40 abajo
        if (this.position < this.index) {
          this.position++;
          this.lsttemp = this.interlocutores[this.position]

          // console.log(this.articulos[this.position])
          // console.log(this.position)
        }
      }
    }
  }

  onNexFocus() {
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
  }


  @ViewChild('tabla') tabla: ElementRef;

  focusMethod2 = function getFocus() {
    document.getElementById("tabla").focus();
  }

  _csearchTerm: string = '';
  get csearchTerm(): string {

    return this._csearchTerm;
  }

  set csearchTerm(val: string) {
    this._csearchTerm = val;

    this.interlocutores = this.cfilter(val);

    console.log("Valores filtrados: ")
    console.log(this.interlocutores)

    // this.totalLengthOfCollection = this.cfilterClient.length;
  }

  onChange(val: any) {

    timerOut(1000).then((value: any) => {
      if (value) {
        if (this._csearchTerm == '' || this._csearchTerm == null) {
          console.log("DEVOLVIENDO VALORES")
          console.log(this.interlocutores_temp)
          this.interlocutores = this.interlocutores_temp;
        }
      }
    });

  }

  cfilter(v: string) {
    if (this._csearchTerm == '') {
      this.interlocutores = this.interlocutores_temp;
      return this.interlocutores;
    }

    console.log("Valor a Buscar: " + this._csearchTerm)

    if (this.cabeceraTipo == '0') {
      return this.TableService.getTable().filter(x => x.codcli.indexOf(v) !== -1 ||
        x.nombresCompletos?.toString().toLowerCase().indexOf(v.toLowerCase()) !== -1);
    } else {

      return this.TableService.getTable().filter(x => x.codcli.indexOf(v) !== -1 ||
        x.razonc?.toString().toLowerCase().indexOf(v.toLowerCase()) !== -1);
    }


  }
}